var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from "vue-property-decorator";
import CookieConsentInfo from "./CookieConsentInfo.vue";
var PrivacyPolicy = /** @class */ (function (_super) {
    __extends(PrivacyPolicy, _super);
    function PrivacyPolicy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.consentedToAll = false;
        return _this;
    }
    Object.defineProperty(PrivacyPolicy.prototype, "showFinnish", {
        get: function () {
            return this.$i18n.locale === "fi";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrivacyPolicy.prototype, "showSwedish", {
        get: function () {
            return this.$i18n.locale === "sv";
        },
        enumerable: false,
        configurable: true
    });
    PrivacyPolicy.prototype.close = function () {
        window.close();
    };
    PrivacyPolicy.prototype.print = function () {
        window.print();
    };
    PrivacyPolicy.prototype.created = function () {
        this.consentedToAll = this.cookiePolicy.isAll();
    };
    Object.defineProperty(PrivacyPolicy.prototype, "cookiePolicy", {
        get: function () {
            return this.$store.getters["vuexPageModule/cookiePolicy"];
        },
        enumerable: false,
        configurable: true
    });
    PrivacyPolicy.prototype.consentAll = function () {
        var policy = this.cookiePolicy;
        policy.consentToAll();
        this.consentedToAll = true;
        this.$store.commit("vuexPageModule/SET_COOKIEPOLICY", policy);
    };
    PrivacyPolicy.prototype.consentNecessary = function () {
        var policy = this.cookiePolicy;
        policy.consentToNecessaryOnly();
        this.consentedToAll = false;
        this.$store.commit("vuexPageModule/SET_COOKIEPOLICY", policy);
    };
    PrivacyPolicy = __decorate([
        Component({
            name: "PrivacyPolicy",
            components: {
                CookieConsentInfo: CookieConsentInfo
            }
        })
    ], PrivacyPolicy);
    return PrivacyPolicy;
}(Vue));
export default PrivacyPolicy;
